'use es6';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import UIMain from '../layout/UIMain';
import * as CustomRenderer from '../utils/propTypes/customRenderer';
import { GRID_BREAKPOINT_SMALL, NAV_ITEM_PADDING_LEFT } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GRID_GUTTER_WIDTH_HALF = '16px';
const SIDEBAR_FULL_WIDTH = '256px';
const SIDEBAR_INNER_WIDTH = '224px';
const Outer = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__Outer",
  componentId: "sc-35md5k-0"
})(["display:flex;flex-wrap:nowrap;margin-left:", ";margin-right:", ";@media only screen and (max-width:", "){flex-wrap:wrap;}"], ({
  flush
}) => !flush && `-${GRID_GUTTER_WIDTH_HALF}`, ({
  flush
}) => !flush && `-${GRID_GUTTER_WIDTH_HALF}`, GRID_BREAKPOINT_SMALL);
const Sidebar = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__Sidebar",
  componentId: "sc-35md5k-1"
})(["flex:0 0 33%;max-width:", ";padding-left:", ";padding-right:", ";position:relative;", ";@media only screen and (max-width:", "){flex-basis:100%;max-width:none;}"], ({
  flush
}) => flush ? SIDEBAR_FULL_WIDTH : SIDEBAR_INNER_WIDTH, ({
  flush
}) => !flush && GRID_GUTTER_WIDTH_HALF, ({
  flush
}) => !flush && GRID_GUTTER_WIDTH_HALF, ({
  sidebarStyle
}) => sidebarStyle, GRID_BREAKPOINT_SMALL);
const MainContainer = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__MainContainer",
  componentId: "sc-35md5k-2"
})(["flex:1 0 0%;max-width:", ";padding-left:", ";padding-right:", ";position:relative;@media only screen and (max-width:679px){max-width:", ";}@media only screen and (max-width:", "){flex-basis:100%;max-width:100%;}"], ({
  hasSidebar,
  flushSidebar
}) => hasSidebar ? `calc(100% - ${flushSidebar ? SIDEBAR_FULL_WIDTH : SIDEBAR_INNER_WIDTH})` : '100%', GRID_GUTTER_WIDTH_HALF, GRID_GUTTER_WIDTH_HALF, ({
  hasSidebar
}) => hasSidebar && '67%', GRID_BREAKPOINT_SMALL);
const STICKY_STYLES = css(["max-height:calc(100vh - var(--uicomponents-global-nav-height));margin-left:-", ";overflow-y:auto;padding-left:", ";position:sticky;top:0;@media only screen and (max-width:", "){height:auto;}"], NAV_ITEM_PADDING_LEFT, NAV_ITEM_PADDING_LEFT, GRID_BREAKPOINT_SMALL);
const SidebarContainer = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__SidebarContainer",
  componentId: "sc-35md5k-3"
})(["", ";"], props => props.stickySidebar && STICKY_STYLES);
export default function UIAbstractPageGridContent(props) {
  const {
    children,
    mainClassName,
    sidebarAreaFlush,
    sidebarComponent,
    sidebarStyle,
    stickySidebar
  } = props;
  return /*#__PURE__*/_jsxs(Outer, {
    flush: sidebarAreaFlush,
    children: [sidebarComponent && /*#__PURE__*/_jsx(Sidebar, {
      flush: sidebarAreaFlush,
      sidebarStyle: sidebarStyle,
      children: /*#__PURE__*/_jsx(SidebarContainer, {
        stickySidebar: stickySidebar,
        children: CustomRenderer.render(sidebarComponent)
      })
    }), /*#__PURE__*/_jsx(MainContainer, {
      hasSidebar: !!sidebarComponent,
      flushSidebar: sidebarAreaFlush,
      children: /*#__PURE__*/_jsx(UIMain, {
        className: mainClassName,
        flush: true,
        children: children
      })
    })]
  });
}
UIAbstractPageGridContent.propTypes = {
  children: PropTypes.node,
  sidebarComponent: CustomRenderer.propType,
  sidebarAreaFlush: PropTypes.bool.isRequired,
  sidebarStyle: PropTypes.object,
  stickySidebar: PropTypes.bool,
  mainClassName: PropTypes.string
};
UIAbstractPageGridContent.defaultProps = {
  sidebarAreaFlush: false,
  stickySidebar: false
};
UIAbstractPageGridContent.displayName = 'UIAbstractPageGridContent';